var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards_container is-flex"},_vm._l((_vm.displayCards),function(card,index){return _c('CardVentas',_vm._b({key:index,staticClass:"mr-4"},'CardVentas',card,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }